import { Form, FormDate, FormInput, FormSwitch } from 'metrix-common3';
// biome-ignore lint/correctness/noUnusedImports: React is required for JSX transformation
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
    AGREE_EMAIL_LABEL_IDS,
    mayRecordSellerAgreement,
    RECORD_SELLER_AGREEMENT,
} from '../../../../constants/policy/sellerAgreement';

// The seller's agreement on a policy converted from a certificate (PBI 24307): whether they agreed
// and when, which an administrator can record, and the Agree email they were sent, read-only. Saved
// through its own action rather than with the policy, so it can be recorded once the card is held,
// when the rest of the policy is read-only.
const ProfileSecureMyOfferSellerAgreement = (props) => {
    const intl = useIntl();
    const info = props.policy?.secureMyOfferCustomInfo;

    if (!info?.isConvertedFromCertificate) {
        return null;
    }

    const set = (code, value) => props.doReducePolicyElement({ code: `secureMyOfferCustomInfo.${code}`, value });
    const emailCode = info.sellerAgreeEmailTemplateCode;
    const agreeEmail = emailCode
        ? intl.formatMessage(
              { id: AGREE_EMAIL_LABEL_IDS[emailCode] ?? 'Profile_SecureMyOffer_SellerAgreement.agreeEmail.unknown' },
              { code: emailCode },
          )
        : intl.formatMessage({ id: 'Profile_SecureMyOffer_SellerAgreement.agreeEmail.none' });

    return (
        <Form
            pageCode={props.pageCode}
            sectionCode='sellerAgreement'
            saveTooltipInfo={() => props.doUpsertTooltipInfo(props.policy.product)}
            reduceTooltipInfoElement={props.doReduceTooltipInfoElement}
            tooltipInfo={props.tooltipInfo}
            validationInfo={props.validationInfo}
            header={<FormattedMessage id='Profile_SecureMyOffer_SellerAgreement.header' />}
            saveEvent={() => props.doExecutePolicyAction({ code: RECORD_SELLER_AGREEMENT })}
            cancelEvent={props.doGetPolicy}
            allowEdit={mayRecordSellerAgreement(props.policy, props.context?.session?.userType)}
        >
            <FormSwitch
                fieldCode='applicationDeclarationAccepted'
                label={<FormattedMessage id='Profile_SecureMyOffer_SellerAgreement.agreed' />}
                value={info.applicationDeclarationAccepted === true}
                changeEvent={(value) => {
                    set('applicationDeclarationAccepted', value);
                    // Agreed needs its date: today's, until another is picked; none once taken back.
                    if (value && !info.sellerAgreedOn) {
                        set('sellerAgreedOn', new Date().toISOString());
                    }
                    if (!value) {
                        set('sellerAgreedOn', null);
                    }
                }}
                allowEdit
            />
            <FormDate
                fieldCode='sellerAgreedOn'
                label={<FormattedMessage id='Profile_SecureMyOffer_SellerAgreement.agreedOn' />}
                value={info.sellerAgreedOn}
                changeEvent={(value) => set('sellerAgreedOn', value)}
                culture={props.context.session.culture}
                mode='past'
                take={11}
                skip={-6}
                allowEdit={info.applicationDeclarationAccepted === true}
            />
            <FormInput
                fieldCode='sellerAgreeEmail'
                label={<FormattedMessage id='Profile_SecureMyOffer_SellerAgreement.agreeEmail' />}
                value={agreeEmail}
                allowEdit={false}
            />
            {info.sellerAgreeEmailSentOn && (
                <FormDate
                    fieldCode='sellerAgreeEmailSentOn'
                    label={<FormattedMessage id='Profile_SecureMyOffer_SellerAgreement.agreeEmailSentOn' />}
                    value={info.sellerAgreeEmailSentOn}
                    culture={props.context.session.culture}
                    time
                    allowEdit={false}
                />
            )}
        </Form>
    );
};

export default ProfileSecureMyOfferSellerAgreement;
